import { v4 as uuid } from 'uuid';

export const generateNotificationId = (): string => {
  const crypto = globalThis?.crypto;

  if (crypto?.randomUUID !== undefined) {
    return crypto.randomUUID();
  }

  return uuid();
};
